// service/Hooks/Titres/useTransactionForm.js
import { useState, useEffect, useCallback } from 'react';
import { toast } from 'sonner';

export const useTransactionForm = (security) => {
  const [formData, setFormData] = useState({
    securityId: security?.securityId || null,
    quantity: '',
    transactionType: '',
    accountCategory: '',
    dateOperation: null, // CHANGÉ : null au lieu de date pré-remplie
    dateCredit: null,    // CHANGÉ : null au lieu de date pré-remplie
    operationNature: '',
    fromAccountId: null,
    toAccountId: null,
    fromAccountCategory: '',
    conversionSecurityId: null,
    documents: []
  });

  // Mettre à jour l'ID du titre quand la sécurité change
  useEffect(() => {
    if (security?.securityId) {
      setFormData(prev => ({
        ...prev,
        securityId: security.securityId
      }));
    }
  }, [security]);

  const updateField = useCallback((field, value) => {
    // console.log(`Mise à jour du champ ${field}:`, value);
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  }, []);

  const handleFileUpload = useCallback((files) => {
    if (!files || files.length === 0) {
      // console.log(' Aucun fichier fourni');
      return;
    }
    
    const newFiles = Array.from(files);
    // console.log(` Tentative d'ajout de ${newFiles.length} fichiers:`, newFiles.map(f => f.name));
    
    // Vérifier la taille des fichiers (max 10MB)
    const oversizedFiles = newFiles.filter(file => file.size > 10 * 1024 * 1024);
    if (oversizedFiles.length > 0) {
      // console.error('Fichiers trop volumineux:', oversizedFiles.map(f => f.name));
      toast.error(`${oversizedFiles.length} fichier(s) dépassent 10MB`);
      return;
    }
    
    // Vérifier le nombre total de fichiers
    setFormData(prev => {
      const totalFiles = prev.documents.length + newFiles.length;
      
      if (totalFiles > 20) {
        // console.error('Trop de fichiers:', totalFiles);
        toast.error('Maximum 20 fichiers autorisés');
        return prev;
      }
      
      const updatedDocuments = [...prev.documents, ...newFiles];
      // console.log(`Documents mis à jour. Total: ${updatedDocuments.length}`);
      // console.log('Documents actuels:', updatedDocuments.map(f => ({ name: f.name, size: f.size, type: f.type })));
      
      return {
        ...prev,
        documents: updatedDocuments
      };
    });
    
    toast.success(`${newFiles.length} fichier(s) ajouté(s)`);
  }, []);

  const removeDocument = useCallback((index) => {
    setFormData(prev => {
      const removedFile = prev.documents[index];
      // console.log(`Suppression du fichier: ${removedFile?.name}`);
      
      return {
        ...prev,
        documents: prev.documents.filter((_, i) => i !== index)
      };
    });
    
    toast.success('Fichier supprimé');
  }, []);

  const resetForm = useCallback(() => {
    // console.log('Réinitialisation du formulaire');
    setFormData({
      securityId: security?.securityId || null,
      quantity: '',
      transactionType: '',
      accountCategory: '',
      dateOperation: null,
      dateCredit: null,
      operationNature: '',
      fromAccountId: null,
      toAccountId: null,
      fromAccountCategory: '',
      conversionSecurityId: null,
      documents: []
    });
  }, [security]);

  return {
    formData,
    updateField,
    resetForm,
    handleFileUpload,
    removeDocument,
    setFormData
  };
};